import { toast } from "@/v2-ui/toast"
import ActionMenu, {
  type ActionMenuItemProps,
} from "@/v2-backoffice-client/components/actionMenu"
import { useInvitationResendMutation } from "@/v2-backoffice-client/invitation/resend/invitation.resend.mutation"
import { INVITATION_RESENT_TITLE } from "@/v2-backoffice-client/invitation/resend/invitation.resend.constants"

export type InvitationResendMenuItemProps = Omit<
  ActionMenuItemProps,
  "onClick"
> & {
  invitationId: number
  onCompleted?(): void
}

function InvitationResendMenuItem(props: InvitationResendMenuItemProps) {
  const { invitationId, onCompleted, ...menuItemProps } = props

  const [resendInvitation, { loading, error }] = useInvitationResendMutation({
    onCompleted(data) {
      toast({
        variant: "success",
        title: INVITATION_RESENT_TITLE,
        description: data.resendUserInvitation?.Email ?? undefined,
      })
      onCompleted?.()
    },
  })

  return (
    <ActionMenu.ConfirmItem
      iconSrc="paper-plane"
      isLoading={loading}
      error={error}
      confirmVariant="warning"
      errorTitle="Failed to resend invitation"
      confirmTitle="Resend Invitation"
      confirmDescription="Are you sure you want to resend this invitation?"
      confirmText="Resend"
      onConfirm={async () => {
        await resendInvitation({ variables: { id: invitationId } })
      }}
      {...menuItemProps}
    >
      Resend Invitation
    </ActionMenu.ConfirmItem>
  )
}

export default InvitationResendMenuItem
